/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Hassan Haroon",
  title: "Hi I'm Hassan",
  subTitle: emoji(
    "A passionate mern stack developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1sFV9D8IUALqKUllJDoB4U2Vd73qOFe9K/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/hassanharoon321",
  linkedin: "https://www.linkedin.com/in/hassan-haroon-88740916a/",
  gmail: "hassanharoon321@gmail.com",
  gitlab: "https://gitlab.com/hassanharoon321",
  facebook: "https://www.facebook.com/hassanharoon007/",
  medium: "https://medium.com/@hassanharoon321",
  stackoverflow: "https://stackoverflow.com/users/12292696/hassan-haroon",
  leetCode: "https://leetcode.com/hassanharoon321/",
  fiverr: "https://www.fiverr.com/hassan_haroon21/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY MERN STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Benazir Bhutto Shaheed University",
      logo: require("./assets/images/bbsul.png"),
      subHeader: "Bachelors of Science in Computer Science",
      duration: "August 2018 - December 2021",
      desc: "Participated in the research of Blockchain and published 1 papers."
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    }
    // {
    //   schoolName: "Stanford University",
    //   logo: require("./assets/images/stanfordLogo.png"),
    //   subHeader: "Bachelor of Science in Computer Science",
    //   duration: "September 2013 - April 2017",
    //   desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
    //   descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    // }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "100%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "95%"
    },
    {
      Stack: "Problem Solving",
      progressPercentage: "95%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/vertexFax.svg"),
      blackImage: require("./assets/images/vertex.svg"),
      projectName: "Vertex 360",
      projectDesc:
        "Manage your NDIS business with ease—track progress, stay compliant, and access plans and checks anytime, anywhere.",
      footerLink: [
        {
          name: "Visit Website",
          // url: "https://qa.vertex360.io/"
          url: "https://vertex360.io/"
        }
      ]
    },
    {
      image: require("./assets/images/real-estate.png"),
      blackImage: require("./assets/images/real-estate.png"),
      projectName: "Real Estate Source Inc",
      projectDesc:
        "A platform where users can create and manage real estate transactions, upload necessary forms, and streamline property dealings online",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://realestatesourceinc.info/"
        }
      ]
    },
    {
      image: require("./assets/images/st.png"),
      blackImage: require("./assets/images/st.png"),
      projectName: "Spatial Think",
      projectDesc:
        "Modern workforce training & collaboration with immersive 3d",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://spatialthink.com/"
        }
      ]
    },
    {
      image: require("./assets/images/cvvlogs.svg"),
      blackImage: require("./assets/images/cvvlogs.svg"),
      projectName: "Cvvlogs",
      projectDesc:
        "Job portal where candidates can find job through their video resume & recruiters can posts jobs, scheduled an interview also hired candidates",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.linkedin.com/company/cvvlogs-usa/"
        }
        //  you can add extra buttons here.
      ]
    },
    // {
    //   image: require("./assets/images/updated-thiaza.png"),
    //   blackImage: require("./assets/images/updated-thiaza.png"),
    //   projectName: "Thiaza",
    //   projectDesc: "Vendor can create a shop set their business time and days & customer can book an appointment",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "https://thiaza-react.herokuapp.com/"
    //     }
    //   ]
    // },
    {
      image: require("./assets/images/forwardme.png"),
      blackImage: require("./assets/images/forwardme.png"),
      projectName: "Forwardme",
      projectDesc: "Shop USA stores Tax free ship internationally",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.forwardme.com/"
        }
      ]
    },
    // {
    //   image: require("./assets/images/inv.PNG"),
    //   blackImage: require("./assets/images/inv.PNG"),
    //   projectName: "Inventive Vision",
    //   projectDesc: "Company portfolio working on Virtual Reality | A better revolution",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "https://www.inventivevisions.com/"
    //     }
    //   ]
    // },
    // {
    //   image: require("./assets/images/devnation.PNG"),
    //   blackImage: require("./assets/images/devnation.PNG"),
    //   projectName: "Devnation app",
    //   projectDesc: "An online learning app to empower 50M youth of Pakistan",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "https://app.thedevnation.com/"
    //     }
    //   ]
    // },

    {
      image: require("./assets/images/davaam.png"),
      blackImage: require("./assets/images/davaam.png"),
      projectName: "Davaam Dashboard",
      projectDesc: "Dashboard to handle real-time data of vending machines",
      footerLink: [
        {
          name: "Visit Website",
          // url: "https://qa.vertex360.io/"
          url: "https://davaam.app/auth/sign-in"
        }
      ]
    },
    {
      image: require("./assets/images/davaam_mobile.png"),
      blackImage: require("./assets/images/davaam_mobile.png"),
      projectName: "Davaam Mobile app",
      projectDesc:
        "Mobile app for topup and E-commerce app for android and ios",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://apps.apple.com/pk/app/davaam-life/id6447618612"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Expertizo certified javascript developer",
      subtitle:
        "Begning of my career starts here I learned basic web designing and development",
      image: require("./assets/images/exp.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Web & mobile engineer",
      subtitle:
        "Learn javascript famous libraries here also saylani gives me knowledge of backend & devops",
      image: require("./assets/images/smit.png"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "Cisco get connected",
      subtitle: "Completed Certifcation from SMIT for Cisco get connected",
      image: require("./assets/images/cisco.png"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3212990048",
  email_address: "hassanharoon321@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "HASSANHAROON323", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
